/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Generating_Audio_PreviewInputs */



/**
* | output |
* | --- |
* | "Generating audio preview..." |
*
* @param {Load_Project_File_Status_Generating_Audio_PreviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_generating_audio_preview = /** @type {((inputs?: Load_Project_File_Status_Generating_Audio_PreviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Generating_Audio_PreviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generation de l'apercu audio...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio-Vorschau wird generiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generazione dell'anteprima audio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание предварительного аудиофайла...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generando vista previa de audio...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在生成音频预览...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオプレビューを生成しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो पूर्वावलोकन तैयार किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerando pré-visualização de áudio...")
	return /** @type {LocalizedString} */ ("Generating audio preview...")
});